export default {

  author: 'Arnaud Blaszkowski',
  name: 'Rugby World Game',
  email: 'contact@compagnie-blasco.com',
  cookies: {
    lang: 'origin_lang',
  },
  locale: ['fr', 'en'],
  loader: true,
  mode: 'out-in',
  prefixRoute: false,
  motion: { duration: .35, y: 75, opacity: 0, delay: .35 },
  rules : [ 'how','duration', 'pro_mode','dices', 'cards', 'actions', 'combine', 'duel','teams', 'keys','fouls', 'twenty_two', 'bonus', 'kickoff', 'counterattack', 'tackle', 'interception', 'free_play','ruck', 'contest','relay', 'pickandgo', 'no_contest','lineout', 'maul','scrum', 'knock_on', 'penalty','choice_hands','advantage', 'choice_lineout', 'run', 'carry', 'kick', 'drop',  'try', 'conversion', 'find_lineout','twenty_two_drop_out' ],
  params: {
    
    fr: {
      "actions": 'actions',  
      "attributs": 'attributs',  
      "bonus": 'bonus', 
      "cartes": 'cards', 
      "charniere-9-10": 'hinge',  
      "combinaisons-de-jeu": 'combine', 
      // "comment-jouer": 'how',
      "composition-equipe": 'teams', 
      "conteste": 'contest',
      "coup-de-pied": 'kick',
      "course": 'run',
      "degagement-en-touche": 'find_lineout',
      "des": 'dices',
      "drop-goal": 'drop',
      "duel": 'duel',
      "duree": 'duration',
      "en-avant": 'knock_on',
      "essai": 'try', 
      "fautes": 'fouls',
      "hors-jeu": 'offside',
      "interception": 'interception',
      "jeu-a-la-main": 'choice_hands',
      "jeu-libre": 'free_play',

      "kickoff": 'kickoff',
      "maul": 'maul',
      "melee": 'scrum',
      "mode-de-jeu": 'pro_mode',  
      "no-contest": 'no_contest',       
      "penalite": 'penalty',
      "penaltouche": 'choice_lineout', 
      "percussion": 'carry', 
      "pick-and-go": 'pickandgo',
      "plaquage": 'tackle', 
      "points-forts": 'keys',
      "regroupement": 'relay', 
      "relance": 'counterattack', 
      "relayeur": 'starter', 
      "retour-a-la-penalite": 'advantage',  
      "renvoi-aux-22-metres": 'twenty_two_drop_out',
      "ruck": 'ruck',   
      "touche": 'lineout',
      "transformation": 'conversion',
      'zone-des-22-metres': 'twenty_two'
    },

    en: {

      "22-meter-area": "twenty_two", 
      "22-drop-out": "twenty_two_drop_out",
      "actions": "actions", 
      "attributes": 'attributs',  
      "back-to-penalty": "advantage", 
      "bonus": "bonus", 
      "cards": "cards",
      "carry": "carry", 
      "composition-of-the-team": "teams",  
      "contest": "contest",
      "conversion": "conversion",
      "counter-attack": "counterattack", 
      "dices": "dices",
      "drop": "drop",  
      "duel": "duel",
      "first-passer": 'starter',
      "fouls": "fouls",
      "free-play": "free_play",
      "game-duration": "duration", 
      "game-mode": "pro_mode",
      
      "half-backs": 'hinge', 
      // "how-to-play": "how",c

      "interception": "interception", 
      "keys-strength": "keys",
      "kick": "kick", 
      "kick-for-touch": "find_lineout",
      "kickoff": "kickoff",
      "knock-on": "knock_on", 
      "lineout": "lineout", 
      "maul": "maul",
      "no-contest": "no_contest",
      "offside": 'offside',
      "penalty": "penalty",
      "penaltouch": "choice_lineout",
      "pick-and-go": "pickandgo",
      "playing-combinations": "combine", 
      "quick-tap": "choice_hands",
      "relay": "relay", 
      "ruck": "ruck", 
      "run": "run", 
      "scrum": "scrum", 
      "tackle": "tackle",  
      "try": "try"      
    }
  },

  link: {
    fb: 'https://www.facebook.com/RugbyWorldGame',
    apple: 'https://apps.apple.com/us/app/rugby-world-game/id6444295275?uo=2',
    google: 'https://play.google.com/store/apps/details?id=com.rugbyworldgame.app',
    rwg: 'https://rugbyworldgame.com'
  },

  game_status_initial: {
    old_context: null,
    context: "Kickoff", 
    score: { 
      home: 0,
      away: 0
    },
    dices: { 
      home: 0,
      away: 0
    },
    opponents: { 
      home: null,
      away: null
    },
    position: 50,
    ball: 'home',
    user: 'home', 
    group: null,
    avantage: null,
    reason: null,
    time: 10,
    user_request: 0,
  },

  players: {
    home: [
      { id:  1, number: 1 },
      { id:  14, number: 14 },
      { id:  9, number: 9 },
      { id:  10, number: 10 },
      { id:  12, number: 12 },
      { id:  15, number: 15 },
    ]
  }

}


